export const LOTTIES = {
  not_found: "https://assets8.lottiefiles.com/packages/lf20_jAWhUR.json",
  firework: "https://assets2.lottiefiles.com/packages/lf20_H5fsdG.json",
  internal_error: "https://assets3.lottiefiles.com/packages/lf20_avt7utpz.json",
  permission_error: "https://assets8.lottiefiles.com/packages/lf20_wwTPJf.json",
};
